<template>
  <div class="homepage-wrapper">
    <v-navigation-drawer
      clipped
      disable-route-watcher
      :mini-variant="!drawer"
      fixed
      value="drawer"
      width="220"
      app
      dark
      class="elevation-10"
    >

      <v-list-tile
        @click.stop="toggleDrawer"
        class="white--text"
      >
        <v-list-tile-action>
          <v-btn flat icon>
            <v-icon>swap_horiz</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-content v-if="drawer">
          <v-list-tile-title>Hide sidebar</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list dense>

        <template v-for="item in items">
          <v-list-group
            v-if="isPageAvailable(item) && item.children"
            :key="item.title"
            v-model="item.model"
          >
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="white--text">
                <v-list-tile-title>
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(child, i) in item.children">
              <v-list-tile
                v-if="isPageAvailable(child)"
                :key="`submenu-item-${child.title}-${i}`"
                :to="child.route"
                exact
                exact-active-class="blue accent-2"
              >
                <v-list-tile-action>
                  <v-icon v-if="child.icon">{{child.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content class="white--text">
                  <v-list-tile-title>
                    {{ child.title }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list-group>

          <v-list-tile
            v-else-if="isPageAvailable(item)"
            :key="item.title"
            :to="item.route"
            exact
            active-class="blue accent-2"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <v-list-tile key="logout" @click="deuthenticateUser">
          <v-list-tile-action>
            <v-icon>keyboard_return</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Logout
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex>
            <router-view />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import {map} from 'ramda'
  export default {
  name: 'Homepage',
  data: () => ({
    drawer: true,
    drawerRight: true,
    right: null,
    left: null,
    items: [
      // role scopes removed because FE-2966
      { icon: 'contact_mail',
        title: 'Blitz',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'Settings', route: "/settings", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Invitation', route: '/invitation', roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Blitz List', route: '/blitz-list', roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Display settings', route: '/display-settings', roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Approved companies', route: '/approved-companies', roleScope: ['manager', 'master', 'super_admin'] },
        ]
      },
      { icon: 'contact_mail',
        title: 'Blitz',
        model: false,
        roleScope: [],
        children: [
          { title: 'Settings', route: "/settings", roleScope: [] },
          { title: 'Invitation', route: '/invitation', roleScope: [] },
          { title: 'Blitz List', route: '/blitz-list', roleScope: [] },
          { title: 'Display settings', route: '/display-settings', roleScope: [] },
          { title: 'Approved companies', route: '/approved-companies', roleScope: [] },
        ]
      },
      { icon: 'access_time',
        title: 'Agenda',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'Locations', route: "/agenda/", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Sessions', route: "/agenda/sessions", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Settings', route: "/agenda/settings", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Events Settings', route: "/agenda/events-settings", roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      { icon: 'supervised_user_circle', title: 'Managers', route: '/users', roleScope: ['master', 'super_admin'] },
      { icon: 'group_work', title: 'Users actions', route: '/actions', roleScope: ['super_admin'] },
      { icon: 'photo_album', title: 'Media folder', route: '/media-folder', roleScope: ['manager', 'master', 'super_admin'] },
      { icon: 'format_list_bulleted', title: 'Categories', route: '/categories', roleScope: ['master', 'super_admin'] },
      { icon: 'card_travel', title: 'Packages', route: '/packages', roleScope: ['master', 'super_admin'] },
      { icon: 'group', title: 'Speakers', route: '/speakers', roleScope: ['manager', 'master', 'super_admin'] },
      { icon: 'monetization_on',
        title: 'Sponsors',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          {title: 'Sponsors List', route: '/sponsors/sponsors-list', roleScope: ['manager', 'master', 'super_admin'] },
          {title: 'Settings', route: '/sponsors/settings', roleScope: ['manager', 'master', 'super_admin'] },
          {title: 'Display', route: '/sponsors/display', roleScope: ['manager', 'master', 'super_admin'] },
          {title: 'Floor plan', route: '/sponsors/floor-plan', roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      { icon: 'rate_review',
        title: 'Notifications',
        model: false,
        roleScope: ['master', 'super_admin'],
        children: [
          {title: 'For admin', route: '/notifications/admin-notifications', roleScope: ['master', 'super_admin'] },
          {title: 'For attendee', route: '/notifications/attendee-notifications', roleScope: ['master', 'super_admin'] },
          {title: 'For events', route: '/notifications/events-notifications', roleScope: ['master', 'super_admin'] }
        ]
      },
      // role scopes removed because FE-2966
      { icon: 'star',
        title: 'Awards',
        roleScope: ['master', 'super_admin'],
        children: [
          { title: 'Categories', route: "/awards/categories", roleScope: ['master', 'super_admin'] },
          { title: 'Nominees', route: "/awards/nominees", roleScope: ['master', 'super_admin'] },
          { title: 'Settings', route: "/awards/settings", roleScope: ['master', 'super_admin'] },
          { title: 'Voting', route: "/awards/voting", roleScope: ['master', 'super_admin'] },
          { title: 'Reminders', route: "/awards/reminders", roleScope: ['master', 'super_admin'] }
        ]
      },
      { icon: 'attachment', title: 'Promo Codes', route: '/promo-codes', roleScope: ['master', 'super_admin'] },
      { icon: 'group_add',
        title: 'Registration',
        model: false,
        roleScope: ['master', 'super_admin'],
        children: [
          { title: 'Settings', route: "/registration", roleScope: ['super_admin'] },
          { title: 'Featured Attendee', route: "/registration/featured-attendee", roleScope: ['super_admin'] },
          { title: 'Invitation', route: "/registration/vip-invitation", roleScope: ['master', 'super_admin'] },
          { title: 'Attendee', route: "/registration/attendee", roleScope: ['master', 'super_admin'] },
          { title: 'Invoices and IPN', route: "/registration/invoices", roleScope: ['master', 'super_admin'] },
          { title: 'Killer Feature', route: "/registration/killer-feature", roleScope: ['master', 'super_admin'] }
        ]
      },
      {
        icon: 'library_books',
        title: 'Static pages',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'Home', route: "/static-pages/content/home", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'About', route: "/static-pages/content/about", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Agenda', route: "/static-pages/content/agenda", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Venue', route: "/static-pages/content/venue", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Speakers', route: "/static-pages/content/speakers", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Sponsors/Exhibitors', route: "/static-pages/content/Sponsors%20&%20Exhibitors", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Contact', route: "/static-pages/content/contact", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Attendee', route: "/static-pages/content/attendee", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Thank you page', route: "/static-pages/content/thank-you", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Awards', route: "/static-pages/content/awards", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Awards individual', route: "/static-pages/content/awards-individual", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Networking blitz', route: "/static-pages/content/networking-blitz", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Trading floor', route: "/static-pages/content/trading-floor", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Video gallery', route: "/static-pages/content/video-gallery", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Terms and conditions', route: "/static-pages/content/terms-and-conditions", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Voucher Page', route: "/static-pages/voucher-page", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Testimonials', route: "/static-pages/testimonials", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Press pack', route: "/static-pages/content/press-pack", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'StartUp', route: "/static-pages/content/start-up", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Virtual page', route: "/static-pages/content/virtual", roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      {
        icon: 'library_books',
        title: 'Static content',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'Footer', route: "/static-pages/content/footer", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Success message', route: "/static-pages/content/success%20message", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Error message', route: "/static-pages/content/error%20message", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Registration-text', route: "/static-pages/content/registration-text", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Registration errors', route: "/static-pages/content/registration-errors", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Voucher', route: "/static-pages/content/voucher", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Social', route: "/static-pages/content/social", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Status Checker', route: "/static-pages/status-checker", roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      { icon: 'chat_bubble', title: 'Testimonials', route: '/testimonials', roleScope: ['manager', 'master', 'super_admin'] },
      { icon: 'mail_outline', title: 'Email Templates', route: '/email-template', roleScope: ['master', 'super_admin'] },
      {
        icon: 'videocam',
        title: 'Videos',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'List', route: "/videos/list", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Display', route: "/videos/display", roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      {
        icon: 'videocam',
        title: 'Venue',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'Book-hotel', route: "/venue-page/book-hotel", roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      {
        icon: 'attachment',
        title: 'Banners',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'List', route: "/banners/list", roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Display', route: "/banners/display", roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      { icon: 'photo_library', title: 'Photo Gallery', route: '/photo-gallery', roleScope: ['manager', 'master', 'super_admin'] },
      { icon: 'developer_board',
        title: 'General settings',
        route: '/general-settings',
        roleScope: ['master', 'super_admin'],
        children: [
          { title: 'Cookies alert', route: "/general-settings/cookies-alert", roleScope: ['master', 'super_admin'] },
          { title: 'Email restriction', route: "/general-settings/email-restriction", roleScope: ['master', 'super_admin'] },
          { title: 'Global Settings', route: "/general-settings/global-settings", roleScope: ['master', 'super_admin'] },
          { title: 'SEO', route: '/general-settings/seo', roleScope: ['master', 'super_admin'] },
          { title: 'Google Sheets', route: '/general-settings/google-sheets', roleScope: ['master', 'super_admin'] },
          { title: 'Google Pixel', route: '/general-settings/google-pixel', roleScope: ['master', 'super_admin'] },
          { title: 'Styles Settings', route: '/general-settings/styles-settings', roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      { icon: 'mail_outline',
        title: 'Listing',
        route: '/listing-settings',
        model: false,
        roleScope: ['manager', 'master', 'super_admin'],
        children: [
          { title: 'Settings', route: '/listing-settings/instruction', roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Invitation', route: '/listing-invitation/single', roleScope: ['manager', 'master', 'super_admin'] },
          { title: 'Listing List', route: '/listing-list', roleScope: ['manager', 'master', 'super_admin'] }
        ]
      },
      { icon: 'library_books',
        title: 'Attendees Messages',
        route: '/attendees-messages',
        model: false,
        roleScope: ['master', 'super_admin']
      },
      { icon: 'library_books',
        title: 'Personal Information',
        route: '/personal-information',
        model: false,
        roleScope: ['manager', 'master', 'super_admin']
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'userScopes',
      'getUserRole'
    ])
  },
  methods: {
    ...mapActions(['deuthenticateUser', 'decodeUserScopes']),
    toggleDrawer(){
      this.drawer = !this.drawer
      const toggleMenuItemView = item => {
        if (item.model) item.model = false
        return item
      }
      this.items = map(toggleMenuItemView, this.items)
    },
    isPageAvailable (item) {
      return item.roleScope.includes(this.getUserRole)
    }
  },
  created () {
    this.decodeUserScopes()
  }
}
</script>

<style lang="scss" scoped>
.homepage-wrapper {
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home/index.vue